module.exports = __webpack_public_path__ + "videos/3d-model_en.c371154.mp4";